import type { TranslationKey } from './types';

const TRANSLATABLE_PREFIXES = ['eo.', 'profile.'] as const;

export function isTranslatableToastKey(msg: string): boolean {
  return TRANSLATABLE_PREFIXES.some((prefix) => msg.startsWith(prefix));
}

export function resolveToastMessage(
  t: (key: TranslationKey) => string,
  msg: string,
  params?: Record<string, string>,
): string {
  if (!isTranslatableToastKey(msg)) return msg;
  let text = t(msg as TranslationKey);
  if (params) {
    for (const [key, value] of Object.entries(params)) {
      text = text.replaceAll(`{${key}}`, value);
    }
  }
  return text;
}
